import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "./context/AuthContext";
import StarryBackground from "./components/StarryBackground";
import ProtectedRoute from "./components/ProtectedRoute";
import AuthCallback from "./components/AuthCallback";
import CookieBanner from "./components/CookieBanner";

import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Onboarding from "./pages/Onboarding";
import Dashboard from "./pages/Dashboard";
import Matches from "./pages/Matches";
import MyMatches from "./pages/MyMatches";
import Compatibility from "./pages/Compatibility";
import Horoscope from "./pages/Horoscope";
import BigThreeReading from "./pages/BigThreeReading";
import BirthChart from "./pages/BirthChart";
import Knowledge from "./pages/Knowledge";
import Subscribe from "./pages/Subscribe";
import PaymentSuccess from "./pages/PaymentSuccess";
import Profile from "./pages/Profile";
import Messages from "./pages/Messages";
import ChatRoom from "./pages/ChatRoom";
import Search from "./pages/Search";
import UserProfile from "./pages/UserProfile";
import Admin from "./pages/Admin";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";

function AppRoutes() {
    const location = useLocation();
    // Handle Emergent OAuth callback BEFORE other routes (race condition fix)
    if (location.hash?.includes("session_id=")) {
        return <AuthCallback />;
    }
    return (
        <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/knowledge" element={<Knowledge />} />
            <Route path="/knowledge/:slug" element={<Knowledge />} />
            <Route path="/onboarding" element={<ProtectedRoute><Onboarding /></ProtectedRoute>} />
            <Route path="/dashboard" element={<ProtectedRoute requireBirthInfo><Dashboard /></ProtectedRoute>} />
            <Route path="/matches" element={<ProtectedRoute requireBirthInfo><Matches /></ProtectedRoute>} />
            <Route path="/my-matches" element={<ProtectedRoute requireBirthInfo><MyMatches /></ProtectedRoute>} />
            <Route path="/compatibility/:userId" element={<ProtectedRoute requireBirthInfo><Compatibility /></ProtectedRoute>} />
            <Route path="/horoscope" element={<ProtectedRoute requireBirthInfo><Horoscope /></ProtectedRoute>} />
            <Route path="/big-three-reading" element={<ProtectedRoute requireBirthInfo><BigThreeReading /></ProtectedRoute>} />
            <Route path="/birth-chart" element={<ProtectedRoute requireBirthInfo><BirthChart /></ProtectedRoute>} />
            <Route path="/subscribe" element={<ProtectedRoute><Subscribe /></ProtectedRoute>} />
            <Route path="/payment/success" element={<ProtectedRoute><PaymentSuccess /></ProtectedRoute>} />
            <Route path="/profile" element={<ProtectedRoute requireBirthInfo><Profile /></ProtectedRoute>} />
            <Route path="/messages" element={<ProtectedRoute requireBirthInfo><Messages /></ProtectedRoute>} />
            <Route path="/messages/:matchId" element={<ProtectedRoute requireBirthInfo><ChatRoom /></ProtectedRoute>} />
            <Route path="/search" element={<ProtectedRoute requireBirthInfo><Search /></ProtectedRoute>} />
            <Route path="/u/:userId" element={<ProtectedRoute requireBirthInfo><UserProfile /></ProtectedRoute>} />
            <Route path="/admin" element={<ProtectedRoute><Admin /></ProtectedRoute>} />
            <Route path="/auth/callback" element={<AuthCallback />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />
        </Routes>
    );
}

function App() {
    return (
        <div className="App">
            <StarryBackground />
            <BrowserRouter>
                <AuthProvider>
                    <AppRoutes />
                    <CookieBanner />
                    <Toaster
                        theme="dark"
                        toastOptions={{
                            style: {
                                background: "rgba(10,10,26,0.9)",
                                border: "1px solid rgba(230,195,135,0.3)",
                                color: "#F5F6F8",
                                fontFamily: "'Outfit', sans-serif",
                            },
                        }}
                    />
                </AuthProvider>
            </BrowserRouter>
        </div>
    );
}

export default App;
